<template>
  <div class="group-block">
    <h3 class="group-block__title">{{ $t('view.flow.block.group.title') }}</h3>
    <div class="group-block__wrapper">
      <sw-button
        v-model="operationBool"
        :label="$t('view.flow.block.group.groupOperation')"
        :onText="$t('btn.assign')"
        :offText="$t('btn.delete')"
        alwaysActive
        @input="onInput"
      ></sw-button>
      <sel
        :label="$t('view.flow.block.group.targetGroup')"
        v-model="val.groupUuid"
        class="group-block__select"
        @input="onInput"
      >
        <option
          v-for="group in $store.state.usersGroups"
          :key="group.id"
          :value="group.uuid"
        >{{ group.name }}</option>
      </sel>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      operationBool: true,
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
    this.operationBool = (this.value.operation === 'assign')
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  },
  watch: {
    operationBool (act, old) {
      if (act) this.val.operation = 'assign'
      else this.val.operation = 'delete'
      this.$emit('input', this.val)
    }
  }
}
</script>

<style lang="scss" scoped>
.group-block {
  @include flowElementShadow();
  width: 30%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;

  &__title {
    margin: 9px 0 12px 0;
    text-align: left;
  }

  &__wrapper {
    @include alignedFlex(space-around);
    align-items: baseline;
    width: 100%;
    text-align: center;
  }

  &__select {
    margin-top: 10px;
    width: 70%;
  }
}
</style>
